import { styled } from "~/stitches.config";
import { Box } from "./box";

export const HighlightContent = styled(Box, {
  spacingLayout: "copy",
  bg: "$whiteLilac",
  p: "$3_5 $4",
  "@md": { p: "$5 $6", mx: "calc(var(--page-container-padding-x) * -1)" },
  color: "$grayHeavy",
  text: "body1",
});
